import { Box, styled } from "@mui/material";

export const SectionHeader = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const SectionContent = styled(Box)({
  position: "relative",
  paddingBottom: "32px",
});

export const Panel = styled(Box)(({ theme }) => ({
  background: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
  padding: theme.spacing(3),
}));

export const Label = styled(Box)(({ theme }) => ({
  minWidth: "146px",
  fontSize: 14,
  fontWeight: 600,
  marginBottom: theme.spacing(0.5),
}));

export const Value = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  fontSize: 14,
  color: theme.palette.text.primary,
  wordWrap: "break-word",
  overflowWrap: "break-word",
  "& a": {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

export const ColumnPlaceholder = styled(Box)(({ theme }) => ({
  width: "200px",
}));

export const RightColumn = styled(Box, { shouldForwardProp: (prop) => prop !== "hideBorder" })(
  ({ theme, hideBorder }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    paddingBottom: "28px",
    borderBottom: hideBorder ? "none" : `1px solid ${theme.palette.divider}`,
  })
);

export const ContentWrapper = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "200px 1fr",
  gap: theme.spacing(4),
}));